import { useEffect, useState } from 'react'
import { useI18n } from '../i18n'
import { api } from '../lib/api'
import { dialogTitle, lastPreview } from '../lib/dialogs'
import { useSession } from '../store/session'
import type { DialogSummary } from '../lib/types'

export function Dialogs() {
  const { t, locale } = useI18n()
  const s = useSession()
  const [list, setList] = useState<DialogSummary[] | null>(null)
  const [err, setErr] = useState(false)

  useEffect(() => {
    api.listDialogs().then((r) => setList(r.dialogs)).catch(() => setErr(true))
  }, [])

  const open = async (d: DialogSummary) => {
    try {
      const full = await api.getDialog(d.id)
      s.set({ activeDialog: full, focusMsgId: null })
      s.go('room')
    } catch {
      setErr(true)
    }
  }

  const loc = locale === 'ru' ? 'ru-RU' : 'en-US'

  return (
    <section className="screen">
      <h2>{t.dialogs.title}</h2>
      <p className="lead">{t.dialogs.lead}</p>
      {err && <div className="banner">{t.errors.threadFailed}</div>}
      {list && !list.length && <p className="muted" style={{ marginTop: 14 }}>{t.dialogs.empty}</p>}
      {list?.map((d) => {
        const title = dialogTitle(d, t)
        const when = d.last ? new Date(d.last.createdAt) : new Date(d.createdAt)
        return (
          <div className="dlg-item" key={d.id} onClick={() => open(d)}>
            {d.last?.img ? <img src={d.last.img} alt="" /> : <div className="ph">{title.slice(0, 1)}</div>}
            <div className="dlg-meta">
              <b>{title}</b>
              <div>{lastPreview(d, t) || t.dialogs.participants(d.participants.length)}</div>
            </div>
            <div className="dlg-right">
              <span className="muted" style={{ fontSize: 11 }}>
                {when.toLocaleDateString(loc, { day: 'numeric', month: 'short' })}
              </span>
              {d.unread > 0 && <span className="badge">{d.unread}</span>}
              {d.streak > 0 && <span className="streak-tag">{t.dialogs.streak(d.streak)}</span>}
            </div>
          </div>
        )
      })}
    </section>
  )
}
